import { fabric } from "fabric";

//fabric.Object.prototype.cornerColor = 'blue';
fabric.Object.prototype.cornerStyle = "";
export default fabric;
